import { getConfigType, getDateRangeFilterProperty, getDimensions, getReportConfig, isTimeSeriesReport } from 'reporting-data/report/configReportGetters';
import { getOvertimeTotalsEditorSchema } from 'reporting-data/report/reportEditorsGetters';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { strategy as singleObjectDimensionStrategy } from '../DimensionEditor/SingleObjectDimensionEditor';
import { BaseOvertimeTotalsEditor } from './BaseOvertimeTotalsEditor';
import { getFirstNonDateDimension } from './overtimeTotalsEditorUtils';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const strategy = {
  isSupportedForReport: report => {
    // Because this is a non-standard Editor that is not displayed in the Editor bar, we are checking
    // that the editor schema exists in the report here, instead via matchesEditorType pattern
    return !!getOvertimeTotalsEditorSchema(report) && isConfigReport(report) && !!getDateRangeFilterProperty(getReportConfig(report)) && singleObjectDimensionStrategy.isSupportedForReport(report);
  },
  getTotalsDimension: report => {
    if (getConfigType(report) === AGGREGATION) {
      return getDimensions(report).get(0);
    }
  },
  getDateDimension: report => {
    if (isTimeSeriesReport(report)) {
      return getDimensions(report).get(0);
    }
  },
  getBreakdown: report => {
    return getDimensions(report).get(1);
  },
  getDefaultTotalsDimension: (report, dimensionEditor, properties) => {
    if (isTimeSeriesReport(report)) {
      return getFirstNonDateDimension(dimensionEditor, properties);
    } else {
      return getDimensions(report).get(0);
    }
  },
  getDefaultDateDimension: report => {
    if (isTimeSeriesReport(report)) {
      return getDimensions(report).get(0);
    } else {
      return getDateRangeFilterProperty(getReportConfig(report));
    }
  }
};
export function SingleObjectOvertimeTotalsEditor(props) {
  return /*#__PURE__*/_jsx(BaseOvertimeTotalsEditor, Object.assign({}, props, {
    strategy: strategy
  }));
}